import styled from "styled-components";

export const Reveal = styled.div<{ $visible: boolean }>`
  display: grid;
  grid-template-rows: ${({ $visible }) => ($visible ? "1fr" : "0fr")};
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition:
    grid-template-rows 220ms ease,
    opacity 220ms ease;
  pointer-events: ${({ $visible }) => ($visible ? "auto" : "none")};
`;

export const RevealInner = styled.div`
  overflow: hidden;
`;

export const Box = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  padding: 16px;
  border: 1px solid #e7e8ec;
  border-radius: 5px;
  box-sizing: border-box;

  @media (max-width: 578px) {
    flex-direction: column;
    gap: 8px;
    padding: 12px;
  }
`;

export const Column = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const Item = styled.li`
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 20px;
  font-family: "Noto Sans", sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  color: #5e5e60;
`;

export const IconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 18px;
  flex-shrink: 0;
`;
